module.exports = __webpack_public_path__ + "img/SK36869856.f6b24c9c.svg";